// material-ui
import React, { useContext } from "react";
import { Box, Stack, Typography, Chip } from "@mui/material";

// project imports
import { useDispatch, useSelector } from "store";
// assets
//import io from "socket.io-client";
import { getWithdrawrequestlist } from "store/slices/user";
import { SocketContext } from "../../../SocketContext";
import { RequestQuoteRounded as WithdrawIcon } from "@mui/icons-material";

// ==============================|| WITHDRAW REQUEST BADGE ||============================== //

const WithdrawRequestBadge = () => {
  const socket = useContext(SocketContext);
  const dispatch = useDispatch();
  const { withdrawrequestlist } = useSelector((state) => state.user);
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    socket.emit("get-client-count", "get");
    socket.on("withdraw-request-listen", () => {
      dispatch(getWithdrawrequestlist());
    });

    return () => {
      socket.off("withdraw-request-listen");
      socket.off("client-count");
    };
  }, [dispatch, socket]);

  React.useEffect(() => {
    dispatch(getWithdrawrequestlist());
  }, [dispatch]);

  React.useEffect(() => {
    setData(withdrawrequestlist);
  }, [withdrawrequestlist]);

  return (
    <Box
      sx={{
        mb: 3,
        background:
          data?.length > 0
            ? "linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.1) 100%)"
            : "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
        backdropFilter: "blur(10px)",
        borderRadius: "16px",
        border:
          data?.length > 0
            ? "1px solid rgba(239, 68, 68, 0.2)"
            : "1px solid rgba(102, 126, 234, 0.2)",
        p: 2.5,
        transition: "all 0.3s ease",
        boxShadow:
          data?.length > 0
            ? "0 4px 20px rgba(239, 68, 68, 0.15)"
            : "0 4px 20px rgba(102, 126, 234, 0.1)",
        animation: data?.length > 0 ? "pulse 2s ease-in-out infinite" : "none",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow:
            data?.length > 0
              ? "0 6px 24px rgba(239, 68, 68, 0.2)"
              : "0 6px 24px rgba(102, 126, 234, 0.15)",
        },
        "@keyframes pulse": {
          "0%, 100%": {
            boxShadow: "0 4px 20px rgba(239, 68, 68, 0.15)",
          },
          "50%": {
            boxShadow: "0 4px 24px rgba(239, 68, 68, 0.3)",
          },
        },
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box
          sx={{
            background:
              data?.length > 0
                ? "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)"
                : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            borderRadius: "12px",
            p: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow:
              data?.length > 0
                ? "0 4px 12px rgba(239, 68, 68, 0.3)"
                : "0 4px 12px rgba(102, 126, 234, 0.3)",
          }}
        >
          <WithdrawIcon sx={{ color: "#fff", fontSize: 28 }} />
        </Box>
        <Stack spacing={0.5} sx={{ flex: 1 }}>
          <Typography
            variant="caption"
            sx={{
              color: data?.length > 0 ? "#ef4444" : "#667eea",
              fontWeight: 600,
              fontSize: "0.75rem",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            คำขอถอนเงิน
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography
              variant="h2"
              sx={{
                color: data?.length > 0 ? "#ef4444" : "#667eea",
                fontWeight: 800,
                fontSize: "2rem",
              }}
            >
              {data?.length || 0}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                fontWeight: 500,
              }}
            >
              รายการ
            </Typography>
          </Stack>
        </Stack>
        {data?.length > 0 && (
          <Chip
            label="ใหม่"
            size="small"
            sx={{
              background: "#ef4444",
              color: "#fff",
              fontWeight: 700,
              fontSize: "0.7rem",
              height: 24,
              animation: "blink 1.5s ease-in-out infinite",
              "@keyframes blink": {
                "0%, 100%": { opacity: 1 },
                "50%": { opacity: 0.5 },
              },
            }}
          />
        )}
      </Stack>
    </Box>
  );
};

export default WithdrawRequestBadge;
